module.exports = "<p>m-file-picker works!</p>\r\n"